export default {
  props: ['open'],
  data(){
    return {
      isOpen: !!this.open
    }
  },

  computed: {
    iconClass() {
      return this.isOpen ? 'icon-minus-accordion' : 'icon-plus-accordion';
    }
  },

  watch: {
    isOpen(newVal) {
      $('[data-toggle="tooltip"]').tooltip('hide');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/accordion/accordion.js